module.exports = __webpack_public_path__ + "media/images/touch/homescreen48-19e93cc6927b1f810d66632d6d266272.png";